import React, { useState } from 'react'
import axios from 'axios'
import MoveModeForm from './MoveModeForm'
import MoveModeUsage from './MoveModeUsage'
import { t } from '../../i18n'
import SectionTitle from '../shared/sectionTitle'
import { MoveModeType, DurationType, MoveModeUsageDetail } from './models'

interface MoveModePageProps {
  cookingMoveSteps: any[]
  unloadMoveSteps: any[]
  organizationOptions: any[],
  moveMode?: any
  usage?: MoveModeUsageDetail
  currentOrganizationId?: number | null
}

const emptyMoveMode = {
  id: null,
  name: '',
  description: '',
  move_mode_type: 'cooking_mode' as MoveModeType,
  move_mode_organizations: [],
  move_mode_steps: Array(1).fill({
    duration: 0,
    duration_type: 'seconds' as DurationType,
    step_number: 1,
    servo_move_step_id: null }),
}

const MoveModePage: React.FC<MoveModePageProps> = ({
  cookingMoveSteps, unloadMoveSteps, organizationOptions, moveMode: initialMoveMode = null, usage,
  currentOrganizationId = null
}) => {
  const [moveMode, setMoveMode] = useState(initialMoveMode || emptyMoveMode)
  const [saveSuccessful, setSaveSuccessful] = useState<boolean | null>(null)
  const [saveText, setSaveText] = useState('')

  const handleSubmit = (submittedMoveMode, onFinished) => {
    const { move_mode_steps, move_mode_organizations, ...moveMode } = submittedMoveMode
    const body = {move_mode: {
      ...moveMode,
      move_mode_steps_attributes: move_mode_steps,
      move_mode_organizations_attributes: move_mode_organizations,
    }}

    const request = !!moveMode.id ? updateMoveModeRequest(body) : createMoveModeRequest(body)

    request
      .then((resp) => {
        setSaveSuccessful(true)
        setSaveText(t('save_successful', { scope: 'move_modes' }))
        onFinished(true, null)
        setMoveMode(resp.data)
      })
      .catch((error) => {
        setSaveSuccessful(false)
        setSaveText(t('save_failed', { scope: 'move_modes' }))
        onFinished(false, error.response.data)
      })
  }

  const createMoveModeRequest = (moveModeBody) => {
    return axios.post('/admin/move_modes', moveModeBody)
  }

  const updateMoveModeRequest = (moveModeBody) => {
    return axios.put(`/admin/move_modes/${moveMode.id}`, moveModeBody)
  }

  const renderSaveMessage = () => {
    if (saveText) {
      return (
        <div
          className={`alert alert-${saveSuccessful ? 'success' : 'danger'}`}
          role="alert"
        >
          {saveText}
        </div>
      )
    }
  }

  return (
    <>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <SectionTitle rows={[!!moveMode.id ? 'Edit' : 'New', t('move_modes.move_mode')]} />
      </div>
      <div className="card card-robis">
        <div className="row">
          <div className="col-sm-12">
            {renderSaveMessage()}
            <MoveModeForm
              cookingMoveSteps={cookingMoveSteps}
              unloadMoveSteps={unloadMoveSteps}
              organizationOptions={organizationOptions}
              moveMode={moveMode}
              onSubmitForm={handleSubmit}
            />
          </div>
        </div>
      </div>
      {!!moveMode.id && usage && (
        <MoveModeUsage usage={usage} currentOrganizationId={currentOrganizationId} />
      )}
    </>
  )
}

export default MoveModePage
